import { Pipe, PipeTransform } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { AttributeDataType } from '@src/app/shared/enums/AttributeDataType.enum';

@Pipe({
    name: "attributeDataTypePipe",
    standalone: false
})
export class AttributeDataTypePipe implements PipeTransform {
  public attributeDataType = AttributeDataType;
  public attributeDataTypes: any[] = [];

  constructor(public translate: TranslateService) {
  }

  transform(key: any): any {
    for (let item in this.attributeDataType) {
      if (this.attributeDataType === key) {
        return this.translate.instant('ENUMS.ATTRIBUTE_DATA_TYPE_' + key);
      }
    }

    return key;
  }

  getList() {
    this.attributeDataTypes = [];

    for (const [propertyKey, propertyValue] of Object.entries(AttributeDataType)) {
      if (!Number.isNaN(Number(propertyKey))) {
        continue;
      }
      const nameAndText = this.translate.instant('ENUMS.' + propertyKey);
      this.attributeDataTypes.push({id: !!propertyValue, name: nameAndText, text: nameAndText});
    }

    return this.attributeDataTypes;
  }

  getById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(AttributeDataType)) {
      if (propertyValue == Id) {
        const nameAndText = this.translate.instant('ENUMS.' + propertyKey);
        return {id: propertyValue, name: nameAndText, text: nameAndText};
      }
    }
    return null
  }

  getNameById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(AttributeDataType)) {
      if (propertyValue == Id) {
        return 'ENUMS.' + propertyKey;
      }
    }
    return null
  }
}
